/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EventHandlerConfiguration,
} from '../models';
import {
    EventHandlerConfigurationFromJSON,
    EventHandlerConfigurationToJSON,
} from '../models';

/**
 * 
 */
export class EventHandlerConfigurationControllerApi extends runtime.BaseAPI {

    /**
     */
    async getEventHandlerConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventHandlerConfiguration>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admsys/event-handler/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventHandlerConfigurationFromJSON));
    }

    /**
     */
    async getEventHandlerConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventHandlerConfiguration>> {
        const response = await this.getEventHandlerConfigurationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getEventsWithoutListenerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventHandlerConfiguration>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admsys/event-handler/events-without-listener`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventHandlerConfigurationFromJSON));
    }

    /**
     */
    async getEventsWithoutListener(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventHandlerConfiguration>> {
        const response = await this.getEventsWithoutListenerRaw(initOverrides);
        return await response.value();
    }

}
